import React, { useState } from 'react';
import { DateTime } from 'luxon';
import { BIAnalytics } from '@amzn/atoz-shiftapp-utilities';
import { AddOpportunityModalButton } from '../AddOpportunityModalButton';
import { AddOpportunityModalContentFeature } from '../AddOpportunityModalContent';
import { AddOpportunityModalSuccess } from '../AddOpportunityModalSuccess';
import { AddOpportunityModalError } from '../AddOpportunityModalError';
import { ShiftDetailsModalContentFeature } from '../../ShiftDetailsModalContent';
import { OpportunityFlowModalContentTypes } from './OpportunityFlowModalTypes';
import { getOpportunityDetails } from '../../OpportunityCard/getOpportunityDetails';
import { useAddShiftWrapper, useListOfSkills } from '../../../hooks';
import { OpportunityStatuses } from '../OpportunityStatuses';
export function useOpportunityFlowModal(_a) {
    var payRates = _a.payRates, shiftOpportunity = _a.shiftOpportunity;
    var skillsString = useListOfSkills(shiftOpportunity ? shiftOpportunity.skills : []);
    // Analytics callback for AddOpportunityModalContentFeature
    var _b = useState(function () { return function () {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var shift = shiftOpportunity.shift;
        BIAnalytics.twoStepShiftAddConfirmation(DateTime.local().toISO(), shift.id, shift.timeRange.start, shift.timeRange.end, skillsString);
    }; }), onAddShiftConfirmationAnalytics = _b[0], setOnAddShiftConfirmationAnalytics = _b[1];
    var _c = useState(null), modalError = _c[0], setModalError = _c[1];
    var _d = useState(OpportunityFlowModalContentTypes.detail), modalContent = _d[0], setModalContent = _d[1];
    var _e = useAddShiftWrapper({
        shiftOpportunity: shiftOpportunity,
        onCompleted: function () {
            return setModalContent(OpportunityFlowModalContentTypes.success);
        },
        onError: function (error) {
            setModalError(error);
            setModalContent(OpportunityFlowModalContentTypes.error);
        },
        onHasDropPenalty: function () {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            var shift = shiftOpportunity.shift;
            setOnAddShiftConfirmationAnalytics(function () { return function () {
                BIAnalytics.twoStepShiftAddConfirmationViaDetailPage(shift.id, shift.timeRange.start, shift.timeRange.end, skillsString);
            }; });
            BIAnalytics.twoStepAddShiftViaDetailPage(shift.id, shift.timeRange.start, shift.timeRange.end, skillsString);
            setModalContent(OpportunityFlowModalContentTypes.add);
        },
        onNoDropPenalty: function () {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            var shift = shiftOpportunity.shift;
            BIAnalytics.singleStepAddShiftViaDetailPage(shift.id, shift.timeRange.start, shift.timeRange.end, skillsString);
        }
    }), onAddShift = _e.onAddShift, loading = _e.loading;
    var renderModal = function (_a) {
        var close = _a.close;
        if (!shiftOpportunity) {
            return null;
        }
        switch (modalContent) {
            case OpportunityFlowModalContentTypes.detail: {
                var _b = getOpportunityDetails(shiftOpportunity), isEligible = _b.isEligible, unclaimableReasonCodes = _b.unclaimableReasonCodes, hasDropPenalty = _b.hasDropPenalty, isUndroppable = _b.isUndroppable, dropDeadline = _b.dropDeadline, locksBeforeStart = _b.locksBeforeStart;
                // Only show the "add" button if eligible
                var addShiftFooterButton = !isEligible ? null : (React.createElement(AddOpportunityModalButton, { loading: loading, onClick: onAddShift, key: "1" }));
                return (React.createElement(ShiftDetailsModalContentFeature, { close: close, footerButtons: [addShiftFooterButton], shift: shiftOpportunity.shift, payRates: payRates, shiftStatusBanners: React.createElement(OpportunityStatuses, { ineligibilityReasons: unclaimableReasonCodes, hasDropPenalty: hasDropPenalty, isUndroppable: isUndroppable, showAllReasons: true, dropDeadline: dropDeadline, locksBeforeStart: locksBeforeStart }), skills: shiftOpportunity.skills, incentivePay: shiftOpportunity.incentivePay }));
            }
            case OpportunityFlowModalContentTypes.add: {
                return (React.createElement(AddOpportunityModalContentFeature, { close: close, shiftOpportunity: shiftOpportunity, setModalContent: setModalContent, setModalError: setModalError, onAddShiftConfirmationAnalytics: onAddShiftConfirmationAnalytics }));
            }
            case OpportunityFlowModalContentTypes.success: {
                return React.createElement(AddOpportunityModalSuccess, { close: close });
            }
            case OpportunityFlowModalContentTypes.error: {
                return (React.createElement(AddOpportunityModalError, { close: close, onRetry: onAddShift, loading: loading, error: modalError }));
            }
        }
    };
    return {
        renderModal: renderModal,
        modalContent: modalContent,
        setModalContent: setModalContent,
        setModalError: setModalError,
        setOnAddShiftConfirmationAnalytics: setOnAddShiftConfirmationAnalytics
    };
}
